
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HisBackendService, HisJobStatus } from 'hisng';
import { PublicationImportInterfaceType } from '../model/publication-import-interface-type';

@Injectable()
export class PublicationImportService {
    constructor( private backendService: HisBackendService ) { }

    loadImportSources(): Observable<PublicationImportInterfaceType[]> {
        return this.backendService.getData( 'api/v1/fs/res/publication/import/systems' );
    }

    startImport(interfaceName: string, searchParams: {[key: string]: string}, runImportJobSynchronous = false ): Observable<HisJobStatus> {
        const queryParams = runImportJobSynchronous ? '?runImportJobSynchronous=true' : '';
        return this.backendService.postData('api/v1/fs/res/publication/import/' + interfaceName + queryParams, searchParams);
    }
}
